export default __webpack_public_path__ + "ffbaec91b1f060c6d400497fdfc287f4.svg";